<template>
  <material-card :title="`Audit Trail`">
    <v-data-table  class="audit_trail_table" small density="compact" fixed-header hide-default-header hide-default-footer hide-footer :items-per-page='-1'
      :headers="headers" :items="filteredItems" :item-class="itemStyle" >
      <template slot='header'>
        <thead class='v-data-table-header'>
          <tr>
            <th :style="{ width: `${header.width}px` }" :class='[`text-${header.align || "left"}`]'
              v-for="header in headers" :key='header.value'><span class='text--lighten-4'>{{ header.text }}</span></th>
          </tr>
          <tr>
            <th v-for="header in headers" :key='header.value' :class='[`text-${header.align || "left"}`, "pb-2"] '>
              <v-text-field
                v-if="['account', 'field_name'].includes(header.value)"
                placeholder="Search"
                autocomplete="off"
                clearable
                density="compact"
                hide-details
                variant="underlined"
                color="success"
                v-model="localFilters[header.value]"
              />

              <template v-if="header.value==='datetime'">
                <input type="date" v-model="localFilters.start_date" /><br/>
                <input type="date" v-model="localFilters.end_date" />
              </template>
            </th>
          </tr>
          </thead>
        </template>
    </v-data-table>
    </material-card>
</template>

<script>
//ISSUE 316
import  moment  from 'moment'
//ISSUE 316
import { getList } from '../../api/base_entity'
import $format from '../../utils/formatter'
export default {
  props: {
    entity: String,
    entity_id: [String, Number],
    fields: Array,
    filters: Object, 
    hideFields: [Array, Object]
  },
  data () {
    return {
      localFilters: { field_name: '', value: '', prev_value: '', account: '', start_date: '', end_date: '' },
      items: [],
      odd: false,
      opened: false,
      headers: [
        { value: 'action', text: 'Action', width: 100},
        { value: 'field_name', text: 'Name', width: 150 },
        { value: 'prev_value', text: 'Before', width: 150 },
        { value: 'value', text: 'After', width: 100 },
        { value: 'account', text: 'Account', width: 70, align: 'right' },
        { value: 'datetime', text: 'Date Time', width: 20, align: 'right' },
      ]
    }
  },
  mounted () {
    this._getData()
  },
  computed: {
    filteredItems () {
      return this.items.filter(i => {

        // field name
        if (this.localFilters.field_name && !i?.field_name?.toLocaleLowerCase().includes(this.localFilters.field_name.toLocaleLowerCase())) {
          return false
        }

        // account 
        if (this.localFilters.account && !i?.account?.toLocaleLowerCase().includes(this.localFilters.account.toLocaleLowerCase())) {
          return false
        }

        if (this.localFilters.start_date && i.datetime < this.localFilters.start_date) {
          return false
        }

        if (this.localFilters.end_date && i.datetime > this.localFilters.end_date) {
          return false
        }

        return i
      })
    }
  },
  methods: {
    //ISSUE 316
    formatDate(x)
    {
      return moment(x).format('DD-MMM-YYYY HH:mm:ss')
    },
    //ISSUE 316
    itemStyle (item) {
      return item.odd ? 'odd' : ''
    },
    _getFieldLabel(field_name) {
      const field = this?.fields?.find(f => f.value === field_name)
      return field?.text ?? $format('field_name', field_name)
    },
    async _getData () {
      let res
      
      if (this.entity_id) {
        res = await getList(`audittrail/${this.entity}/${this.entity_id}`)
      } else {
        res = await getList(`audittrail/${this.entity}`, { filters: this.filters })
      }
      this.items = []
      for(const e of res.data) {
        this.items = this.items.concat(this._getChanges(e))
      }
    },
    _getChanges (entry) {
    
      const ignore_fields = ['id', 'restore_pass_token', 'insert_at', 'password', 'request_id', 'siterequest_id', 'returned_id', 'fullyused_id', 'disposed_id', 'patch_id']
      let changes = []
      for(const field_name in entry.fields) {
        
        if (ignore_fields.includes(field_name)) { continue }
    
        if (this.hideFields && this.hideFields[entry.entity] && this.hideFields[entry.entity].includes(field_name) ) {
          continue
        }
    
        let value
        let prev_value

        //ISSUE 316    
        var fkm = entry.foreigns_map[field_name]
        // se il campo e' una foreign
        if (fkm) {
          value = $format(fkm, entry.foreigns[fkm], 'audit_trail')
          prev_value = $format(fkm, entry.prev_foreigns[fkm], 'audit_trail')
        } else {
          value = $format('field_value', entry.fields[field_name], field_name, 'audit_trail')
          prev_value = $format('field_value', entry.prev_fields[field_name], field_name, 'audit_trail')
        }
        //ISSUE 316    

        // se e' un PUT metto solo i valori nuovi
        const isEdit = entry.http_verb === 'PUT' || ['Confirm','Request', 'Validate', 'Save New Pdf', 'Received', 'Sent'].includes(entry.action)

        if (Array.isArray(value) && Array.isArray(prev_value)) {
             const equal = value.length === prev_value.length && value.every((value, index) => value === prev_value[index])
             if (equal) continue
        }
        if (value === prev_value && isEdit) continue

        // non lo metto se entrambi i valori sono vuoti
        if (!value &&  !prev_value) continue
    
        //issue delete
        if(entry.action.toLowerCase() === 'delete')
        {
          value = ''
        }
        if(entry.action.toLowerCase() === 'insert')
        {
          prev_value = ''
        }
        //issue delete

        //ISSUE 316        
        if (prev_value === null) prev_value = ""
        if (value === null) value = ""
        if ( (prev_value+'').trim() == 'undefined')
        {
          prev_value = ''
        }
        if ( (value+'').trim() == 'undefined')
        {
          value = ''
        }
        if (fkm)
        {
          if (prev_value === '' && value === '')
          {
            continue;
          }
        }

        prev_value = prev_value + ""
        value = value + ""

        if (prev_value === value)
        {
          continue;
        }

        console.log("--" + typeof(prev_value) + "--" + typeof(value) + "--")
        //ISSUE 316


        const re = new RegExp(this.entity, 'gi')
        changes.push({
          action: `${entry.action} ${entry.section}`.replace(re, ''), // entry.http_verb,
          account: entry.insert_by,
          odd: this.odd,
          //ISSUE 316
          datetime: this.formatDate(entry.insert_at),
          //ISSUE 316
          field_name: this._getFieldLabel(field_name),
          prev_value,
          color: entry.color,
          foreign: entry.entity !== this.entity,
          value
        })
      }
    
      //ISSUE 316
      /*
      if (entry.http_verb === 'PUT' && !changes.length) {
        const re = new RegExp(this.entity, 'gi')
        changes.push({
          action: `${entry.action} ${entry.section}`.replace(re, ''),
          account: entry.insert_by,
          datetime: (entry.insert_at),
          color: entry.color,
          odd: this.odd,
          field_name: 'EMPTY UPDATE'
        })
      }
      */
      //ISSUE 316
    
      if (changes.length) {
        this.odd = !this.odd
      }
      return changes
    }
  }
}

</script>
<style>
.odd {
  background-color: beige;
}

.audit_trail_table .v-data-table__wrapper {
  overflow-y: scroll;
  height: min(700px, 70vh);
}

.audit_trail_table td {
  word-wrap: anywhere;
}
</style>
